
const authentication = require('../../../react-azure-adb2c2').default;
export const insert = (values: any) => {

    // const url = process.env.REACT_APP_API_CRM_CONTRACTS_URL + `/api/v1/rent/contract/workflows/` + values.rent_contract_id;
    const url = `http://localhost:5000/api/v1/rent/contract/workflows/` + values.rent_contract_id;
    const token = authentication.getAccessToken();
    //const search = values ? values : {};
    // alert(JSON.stringify(values))

    return fetch(url, {
        method: 'put',
        body: JSON.stringify(values),

        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

    }).then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));

}

